module.exports = __webpack_public_path__ + "img/lite-beach-3.5dc1a628.jpg";